<template>
  <div v-if="$vuetify.breakpoint.xsOnly">
    <configuracion-editar-form @success="success"></configuracion-editar-form>
  </div>
  <v-container fluid grid-list-xl v-else>
    <v-layout row justify-center wrap>
      <v-flex lg6 sm9 xs12>
        <transition name="fade" mode="out-in">
          <div>
            <configuracion-editar-form @success="success"></configuracion-editar-form>
          </div>
        </transition>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {
      'configuracion-editar-form': require('./ConfiguracionEditarForm').default
    },

    methods: {
      success(data) {
        this.$router.go(-1)
      }
    }
  }
</script>
